"use client";

import { useEffect, useState } from "react";

export interface UserContextData {
  email?: string;
  userId?: string;
  anonymousId?: string;
  ipAddress?: string;
  country?: string;
}

export function useUserContext(userData?: {
  email?: string;
  userId?: string;
}): UserContextData {
  const [ipAddress, setIpAddress] = useState<string>();
  const [country, setCountry] = useState<string>();

  useEffect(() => {
    const fetchIpInfo = async () => {
      try {
        const response = await fetch("/api/get-ip");
        if (response.ok) {
          const data = await response.json();
          setIpAddress(data.ip);
          setCountry(data.country);
        } else {
          console.warn("[Datadog] IP API returned error:", response.status);
        }
      } catch (error) {
        console.warn("[Datadog] Failed to fetch IP info:", error);
      }
    };

    fetchIpInfo();
  }, []);

  const getAnonymousId = (): string | undefined => {
    if (typeof document === "undefined") return undefined;

    try {
      const cookies = document.cookie.split(";");
      const yzsaCookie = cookies.find((cookie) =>
        cookie.trim().startsWith("yzsa="),
      );

      if (yzsaCookie) {
        return yzsaCookie.split("=")[1];
      }
    } catch (error) {
      console.warn("[Datadog] Failed to read anonymous ID cookie:", error);
    }

    return undefined;
  };

  return {
    email: userData?.email,
    userId: userData?.userId,
    anonymousId: getAnonymousId(),
    ipAddress,
    country,
  };
}
